/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/house_1'
export default icon
